module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07487_banner_800x600.fe622c79.png";